<app-kpi-widget
  [title]="'fuelChanges.widgets.lossRatio' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="lossRatioPercentageChange"
  [costDifference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [isUptrendPositive]="isUptrendPositive"
  [selectedDropdownValue]="selectedUnit"
  [valueFormatter]="formatValue.bind(this)"
  [costDifferenceFormatter]="formatLossRatioDifference.bind(this)"
  (clicked)="openLossRatioModal()"
  (dropdownChanged)="onDropdownChanged($event)"
  [dropdownEnabled]="false">
</app-kpi-widget>